(function (global) {
  'use strict';

  angular.module('wsLrs.directives').directive('wsCustomChart', [function () {
    return {
      restrict: 'A',
      template: '<div></div>',
      scope: {
        chartConfig: "=value"
      },
      transclude: true,
      replace: true,
      link: function link(scope, element, attrs) {
        var chartConfigDefaults = {
          container: element[0],
          type: attrs.type || null,
          height: attrs.height || null,
          width: attrs.width || null,
          //used by Interaction Timeline to add top margin to month labels
          extraLabelMargin: attrs.extraLabelMargin || null
        };
        var currentCfg = null;
        function render() {
          //NOTE: use of global namespace watershed.charts
          setTimeout(function () {
            global.watershed.charts.render(currentCfg);
          }, 0);
        }
        function resize() {
          // use resize callback if available (provided as a function on the config object)
          if (currentCfg && typeof currentCfg.resize === 'function') {
            currentCfg.resize();
          } else {
            render();
          }
        }

        //Update when charts data changes
        scope.$watch(function () {
          return scope.chartConfig;
        }, function (value) {
          if (value) {
            if (scope.chartConfig.isResize) {
              // no change except window size
              resize();
              scope.chartConfig.isResize = false;
            } else {
              var deepCopy = true;
              currentCfg = {};

              // Special tweak for network graph -- Is this still necessary?
              if (scope.chartConfig.hasOwnProperty("nodes") && scope.chartConfig.hasOwnProperty("links")) {
                currentCfg = scope.chartConfig;
              }
              $.extend(deepCopy, currentCfg, chartConfigDefaults, scope.chartConfig);
              render();
            }
          }
        });

        //  window resize (throttled)
        $(window).on("resize.wsCustomChart", _.debounce(function () {
          scope.$root.$safeApply(resize());
        }, 250));
        scope.$on("$destroy", function () {
          $(window).off("resize.wsCustomChart"); //remove the handler added earlier
        });
      }
    };
  }]);
})(this);
